import { Utilities as U } from '@shared/utilities/utilities.model';
import { DateUtilities } from '@shared/utilities/date-utilities.model';

const DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSS[Z]';

export class GroupChanneling {

	id							 : string = '';
	name						 : string = '';
	description			 : string = '';
	profile					 : string = '';
	num_of_users		 : string = '';
	create_timestamp : Date;
	update_timestamp : Date;

	constructor(model?: any) {

		if (U.isEmpty(model)) {
			return;
		}

		this.id 							= model.id;
		this.name 						= model.name;
		this.description 			= model.description;
		this.profile 					= model.profile;
		this.num_of_users 		= model.num_of_users;
		this.create_timestamp = DateUtilities.getDateFromString(model.create_timestamp, DATE_FORMAT);
		this.update_timestamp = DateUtilities.getDateFromString(model.update_timestamp, DATE_FORMAT);
	}
}
